<div class="d-flex" *ngIf="formGroupRef as formGroup" [formGroup]="formGroup">
  <div class="grow1">
    <div
      class="input-container grow1"
      [attr.data-e2e]="'form:field:' + field.postname"
      *ngIf="formGroup.controls[field.postname]"
    >
      @if(field.type === 'radio_buttons' && field.options !== false) {
      <div
        class="d-flex input-radio"
        [class.flex-column]="field.field_type === 'select'"
        [id]="inputId"
        [attr.data-e2e]="field.postname"
      >
        @for(option of (field.options ? field.options : []); track $index) {
        <div class="grow1">
          @if((option | keyvalue)[0]; as data) {
          <input
            #radioInput
            type="radio"
            [formControlName]="field.postname"
            [value]="data.key"
            [attr.readonly]="field.is_readonly || null"
            [id]="'radio' + data.key"
            (change)="onRadioChange(field)"
            (blur)="onBlur(field)"
            (focus)="onFocus(field)"
          />
          <label class="input-radio" [htmlFor]="'radio' + data.key">
            <span [innerHTML]="data.value"></span>
          </label>
          }
        </div>
        }
      </div>
      } @if(field.type === 'hidden') {
      <input [id]="inputId" type="hidden" [formControlName]="field.postname" [attr.data-e2e]="field.postname" />
      } @if(isTextInput(field)) {
      <input
        (keyup.enter)="onEnter(field)"
        [id]="inputId"
        [attr.data-e2e]="field.postname"
        type="text"
        class="form-control autofill-events"
        [formControlName]="field.postname"
        [placeholder]="field.placeholder"
        [attr.autocomplete]="field.autocomplete || null"
        [attr.readonly]="field.is_readonly || null"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
        #input
      />
      } @if(field.type === 'textarea') {
      <textarea
        [id]="inputId"
        [attr.data-e2e]="field.postname"
        [rows]="field.rows"
        type="text"
        class="form-control"
        [formControlName]="field.postname"
        [placeholder]="field.placeholder"
        [attr.readonly]="field.is_readonly || null"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
      ></textarea>
      } @if(field.type === 'checkbox') {
      <input
        [formControlName]="field.postname"
        [id]="inputId"
        [attr.data-e2e]="field.postname"
        type="checkbox"
        [attr.readonly]="field.is_readonly || null"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
        (change)="onCheckBoxChange()"
      />
      <label
        class="input-checkbox relative"
        [htmlFor]="field.is_readonly ? null : inputId"
        (mouseleave)="checkboxTooltip.hide()"
        (mouseenter)="field.tooltip ? checkboxTooltip.show($event) : null"
        (blur)="checkboxTooltip.hide()"
        (focus)="field.tooltip ? checkboxTooltip.show($event) : null"
      >
        <span
          [innerHTML]="field.label || field.fieldname | sanitize : 'HTML'"
          [class.required-indicator]="field.is_required"
        ></span>
        <span *ngIf="!field.is_required" class="optional-indicator" i18n="@@input.text.optional">(optional)</span>
        <p-overlayPanel #checkboxTooltip>
          <ng-template pTemplate>
            <div *ngIf="field.tooltip" [innerHTML]="field.tooltip | pipeToBr | sanitize : 'HTML'"></div>
          </ng-template>
        </p-overlayPanel>
      </label>
      } @if (field.type === 'select' && field.options && field.multi_select && watchForCheckboxChanges$(field) | async)
      {
      <div
        class="d-flex input-radio"
        [class.flex-column]="field.field_type === 'select'"
        [id]="inputId"
        [attr.data-e2e]="field.postname"
      >
        <div *ngFor="let option of $any(field).options; trackBy: trackByIndex" class="grow1">
          <ng-container *ngIf="(option | keyvalue)[0] as data">
            <input
              *ngIf="field.postname + '_' + data.key as formControlName"
              [formControlName]="formControlName"
              (change)="
                $any($event.target).checked
                  ? formGroup.get(formControlName).patchValue(data.key)
                  : formGroup.get(formControlName).patchValue(null)
              "
              [id]="inputId + '_label_' + data.key"
              [attr.data-e2e]="field.postname + '_label_' + data.key"
              type="checkbox"
              [attr.readonly]="field.is_readonly || null"
              (blur)="onBlur(field)"
              (focus)="onFocus(field)"
              (change)="onCheckBoxChange()"
            />
            <label
              class="input-checkbox relative"
              [htmlFor]="field.is_readonly ? null : inputId + '_label_' + data.key"
            >
              {{ data.value }}
            </label>
          </ng-container>
        </div>
      </div>
      } @if( (field.type === 'select' || field.type === 'salutation') && field.options && !field.multi_select) {
      <p-dropdown
        [filter]="field.options.length > 5"
        class="form-control"
        [ngClass]="{
          disabled: formGroup.controls[field.postname]?.disabled
        }"
        [inputId]="inputId"
        [attr.data-e2e]="field.postname"
        [virtualScroll]="field.options.length > 30"
        [virtualScrollItemSize]="30"
        [options]="field.options | map : mapOptions"
        [formControl]="$any(formGroup.controls[field.postname])"
        optionLabel="name"
        optionValue="key"
        [attr.readonly]="field.is_readonly || null"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
      ></p-dropdown>
      } @if(field.type === 'country') {
      <p-dropdown
        *ngIf="loadCountriesForSelect$ | async as countries"
        i18n-filterPlaceholder="@@dropdown.filter.search"
        filterPlaceholder="Suche"
        [filter]="true"
        class="form-control"
        [ngClass]="{
          disabled: formGroup.controls[field.postname]?.disabled
        }"
        (onShow)="showDropdown = true"
        (onHide)="showDropdown = false"
        [inputId]="inputId"
        [attr.data-e2e]="field.postname"
        [virtualScroll]="countries.length > 30"
        [virtualScrollItemSize]="39"
        [options]="countries"
        [formControl]="$any(formGroup.controls[field.postname])"
        optionLabel="name"
        optionValue="key"
        [attr.readonly]="field.is_readonly || null"
        [readonly]="field.is_readonly || null"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
      ></p-dropdown>
      } @if (field.type === 'date') {
      <p-calendar
        [inputId]="inputId"
        [attr.data-e2e]="field.postname"
        [placeholder]="field.placeholder"
        [inputStyleClass]="'form-control'"
        [formControlName]="field.postname"
        [showTime]="field.with_time"
        [dateFormat]="dateFormat"
        [hourFormat]="hourFormat"
        [minDate]="field.future_date_only ? dateTodayMinMaxValue : null"
        [maxDate]="field.past_dates_only ? dateTodayMinMaxValue : null"
        [readonlyInput]="field.is_readonly || false"
        [hideOnDateTimeSelect]="false"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
      ></p-calendar>
      } @if(field.type === 'int') {
      <input
        [id]="inputId"
        [attr.data-e2e]="field.postname"
        [formControlName]="field.postname"
        *ngIf="field.type === 'int'"
        type="number"
        class="form-control autofill-events"
        [min]="+field.min_value"
        [max]="+field.max_value"
        [maxlength]="+field.maxlength"
        [minLength]="+field.minlength"
        [placeholder]="field.placeholder"
        [attr.autocomplete]="field.autocomplete || null"
        [attr.readonly]="field.is_readonly || null"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
      />
      } @if(field.type === 'email') {
      <input
        [id]="inputId"
        [attr.data-e2e]="field.postname"
        [formControlName]="field.postname"
        type="email"
        class="form-control autofill-events"
        [placeholder]="field.placeholder"
        [attr.autocomplete]="field.autocomplete || null"
        [attr.readonly]="field.is_readonly || null"
        [email]="!field.regex"
        (blur)="onBlur(field)"
        (focus)="onFocus(field)"
      />
      } @if(field.type === 'headline' && field.label) {
      <legend class="mt-3" [id]="inputId" [attr.data-e2e]="field.postname">
        {{ field.label }}
      </legend>
      } @if(field.type === 'html') {
      <div
        [id]="inputId"
        [attr.data-e2e]="field.postname"
        [innerHTML]="field.message_html | sanitize : 'HTML'"
        class="html-input"
      ></div>
      } @if(field.label !== 'skip' && field.type !== 'headline' && field.type !== 'html' && field.type !== 'checkbox' &&
      field.type !== 'hidden') {
      <label
        [htmlFor]="field.postname"
        [ngClass]="{
          'not-move': !!formGroup.controls[field.postname]?.value,
          'transition-label': isTextInput(field) || field.type === 'email'
        }"
      >
        <span [innerHTML]="field.label" [class.required-indicator]="field.is_required"></span>
        <span *ngIf="field.tooltip" [pTooltip]="field.tooltip | pipeToBr" [escape]="false"
          >&nbsp;<i class="fa fa-question-circle" aria-hidden="true"></i
        ></span>
        <span *ngIf="!field.is_required" class="optional-indicator" i18n="@@input.text.optional_with_space_before"
          >&nbsp;(optional)</span
        >
      </label>
      }
    </div>

    <!-- Plugin for inputs -->
    <orderform-address-suggest-plugin
      *ngIf="field.postname === 'buyer_address_street'"
      [inputId]="inputId"
      [inputControl]="formGroup.controls[field.postname]"
      [formGroupRef]="formGroup"
    ></orderform-address-suggest-plugin>
  </div>

  <!-- Addons-->
  <button
    i18n="@@check_tax_id"
    class="button-tax-id btn btn-secondary"
    (click)="validateTaxId()"
    [disabled]="!formGroup.get('buyer_address_tax_id')?.value"
    *ngIf="field.button && field.postname === 'buyer_address_tax_id'"
  >
    Prüfen
  </button>
</div>
